import React from 'react'
import { Modal } from '@therms/atalaya'
import { EntryForm } from './EntryForm'
import { useLocationContext } from '@therms/react-modules'
import { LocationLogsUserAnPGeoConditional } from '../../LocationLogsUserAnPGeoConditional'

interface EntryFormModalProps {
  closeHandler: () => void
  entryId?: string
  entryTypeId?: string
  entryTypeName?: string
  onComplete: () => void
}

function EntryFormModal({
  closeHandler,
  entryId,
  entryTypeId,
  entryTypeName,
  onComplete,
}: EntryFormModalProps) {
  const { locationId } = useLocationContext(true)

  if (entryId) {
    // If editing a log entry, we need to check if the user has permission to edit the entry
    return (
      <Modal
        closeHandler={closeHandler}
        header={entryTypeName ? `${entryTypeName} Entry` : 'Entry'}
        width="xl"
      >
        <LocationLogsUserAnPGeoConditional>
          <EntryForm
            entryId={entryId}
            entryTypeId={entryTypeId}
            locationId={locationId}
            onCancel={closeHandler}
            onComplete={() => {
              closeHandler()
              onComplete()
            }}
          />
        </LocationLogsUserAnPGeoConditional>
      </Modal>
    )
  }

  return (
    <Modal
      closeHandler={closeHandler}
      header={`${entryTypeName} Entry`}
      width="xl"
    >
      <EntryForm
        entryId={entryId}
        entryTypeId={entryTypeId}
        locationId={locationId}
        onCancel={closeHandler}
        onComplete={() => {
          closeHandler()
          onComplete()
        }}
      />
    </Modal>
  )
}

export { EntryFormModal }
